/**
 * Meta Pixel (Facebook) tracking.
 * Only loads in production builds.
 */

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const initializeMetaPixel = (): void => {
  const pixelId = import.meta.env.VITE_META_PIXEL_ID

  if (!pixelId || pixelId.trim() === '') {
    return
  }

  /* eslint-disable */
  const f: any = window
  if (f.fbq) return
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  /* eslint-enable */

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  f.fbq('init', pixelId)
  f.fbq('track', 'PageView')

  // noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}
